export const HEADERS_SIZE = {
  HOME_VAL: 'h4',
  MAIN: 'h2'
}
